import { render, staticRenderFns } from "./MoblieAttentionMessage.vue?vue&type=template&id=4ba9e8ab&scoped=true&"
import script from "./MoblieAttentionMessage.vue?vue&type=script&lang=js&"
export * from "./MoblieAttentionMessage.vue?vue&type=script&lang=js&"
import style0 from "./MoblieAttentionMessage.vue?vue&type=style&index=0&id=4ba9e8ab&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ba9e8ab",
  null
  
)

export default component.exports